import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import BlogsDetailsData from "../components/BlogsDetailsData";
import HowWeHelp from "../components/HowWeHelp";
import BlogsHero from "../components/BlogsHero";

const BlogsDetailsPage = () => {
    const { blogId } = useParams();
    const navigate = useNavigate();

    const handleBackToBlogs = () => {
        navigate('/blogs');
    };

    return (
        <div>
            <BlogsHero />
            <BlogsDetailsData blogId={blogId} />
            <HowWeHelp />
            
            {/* Back to Blogs Button */}
            <div className="text-center mb-5">
                <button 
                    className="back-to-blogs-btn"
                    onClick={handleBackToBlogs}
                >
                    ← Back to All Blogs
                </button>
            </div>
        </div>
    );
};

export default BlogsDetailsPage;
